import './RightElements.css';

const GetProCard = () => (
  <div className="rightmenu-card get-pro-card">
    <div className="get-pro">
      <div className="get-pro-title">Invata fara limite</div>
      <div className="get-pro-desc">
        Activeaza Premium si deblocheaza intreaga experienta ContaLearn!
      </div>
      <div className="go-premium"><span>Incearca premium</span></div>
    </div>
  </div>
);

export default GetProCard;
